// 개선 9건 차수1(26-08-04) §4 (결정 ③A) — 서명관리 화면의 접근 규칙 정본.
//
// 왜 여기에 모으나 — 같은 규칙이 router(ProtectedRoute) · Sidebar · 페이지 안의
// 버튼 노출 세 곳에 필요하다. 세 곳에 각각 적으면 하나만 고쳐져서 "메뉴는 보이는데
// 라우트가 튕긴다" 또는 "버튼은 있는데 403" 이 된다(이 리포가 이미 여러 번 겪은 결함).
//
// ⚠️ 각 집합은 서버와 **정확히 같아야** 한다. 서버 정본은 signature-documents.service
// 의 `SIGNATURE_READ_ROLES` · `SIGNATURE_WRITE_ROLES` · `SIGNATURE_DOWNLOAD_ROLES` ·
// `SIGNATURE_SIGN_OPERATION_ROLES` 네 벌이고, 같은 컨트롤러가 그 배열로 @Roles 를
// 단다(서버 안에서도 값은 한 벌이다 — 차수2c 결함④ 로 네 번째까지 모았다).
//   VIEW     = router requiredRoles / Sidebar allowedRoles.
//              여기 집합은 서버 READ 의 **부분집합**이다 — 서버 READ 는 '고객사 서류'
//              탭을 쓰는 영업(SALES_MANAGER)과 레거시 MANAGER 까지 포함하지만, 이
//              화면(서명관리 메뉴)의 동선은 관리자·필드·제조팀뿐이다. 좁은 쪽이
//              화면이라 넓혀도 서버가 막아 준다.
//   WRITE    = 서버 SIGNATURE_WRITE_ROLES (생성·취소·삭제·복구·재생성).
//   DOWNLOAD = 서버 SIGNATURE_DOWNLOAD_ROLES / service canDownloadPdf.
//
// 개선 9건 차수2b(26-08-04) 결함⑥ — 이 자리의 종전 주석은 "서버는 list·get 에 역할
// 게이트가 없고 법인 스코프만 걸므로 **화면 쪽이 실질 경계**"라고 선언했다. 차수2a 가
// 서버에 그 게이트를 세웠으므로 stale 이었고, 무엇보다 **위험한 거짓**이었다: 다음
// 사람이 "화면만 고치면 안전하다"고 읽을 근거가 된다. 화면은 편의(메뉴·버튼을 숨겨
// 헛클릭을 막는 것)이고 **경계는 언제나 서버**다.
//
// 서명 링크(signUrl) 노출은 **여기서 다루지 않는다** — 서버가 응답에서 아예
// 빼고(canSeeSignUrl), 화면은 값이 없으면 '권한 없음'을 표기한다. raw 서명 토큰은
// 인증 없이 서명할 수 있는 문이라 열람 권한과 섞지 않는다.
//
// 개선 9건 차수2c(26-08-04) 결함④ — 그래서 네 번째 집합
// (`SIGNATURE_SIGN_OPERATION_ROLES` = 서명 링크 노출 + 서명 준비·대행 라우트 4개)의
// 거울을 이 파일에 **두지 않는다.** 화면은 그 값을 알 필요가 없다: 값이 오면 링크를
// 보여 주고 없으면 '권한 없음'이라 적으면 되고, 역할로 갈래를 지으면 서버와 어긋날
// 자리를 새로 만드는 것이다(집합이 늘 때마다 거울을 늘리는 것이 아니라, **화면이
// 실제로 쓰는 것만** 여기 둔다).

import { UserRole, OPERATIONS_ROLES, canOperate } from '@bhops/shared';

/**
 * 서명관리(목록·상세) 열람 가능 역할.
 *
 * 권한 통합(오너 결정 2026-08-27) — "권한이 없어서 보지 못했던 탭도 오픈".
 * 종전 [ADMIN, FIELD_MANAGER, MFG_MANAGER] → 운영 권한 전체. 서버 SIGNATURE_READ_ROLES
 * 와 같은 집합이 됐다(종전엔 화면이 서버보다 좁은 부분집합이었다).
 */
export const SIGN_DOCUMENTS_VIEW_ROLES: ReadonlyArray<UserRole> = OPERATIONS_ROLES;

/**
 * 서명 문서를 만들고·취소하고·지울 수 있는 역할(서버 SIGNATURE_WRITE_ROLES 거울).
 * 권한 통합으로 서버가 운영 권한 전체에 열렸다.
 */
export function canWriteSignDocument(role: UserRole | undefined): boolean {
  return role !== undefined && canOperate(role);
}

/** PDF 를 내려받을 수 있는 역할(서버 DOWNLOAD_ROLES 거울 — 제조팀 포함). */
export function canDownloadSignDocumentPdf(role: UserRole | undefined): boolean {
  return (
    role === UserRole.ADMIN ||
    role === UserRole.FIELD_MANAGER ||
    role === UserRole.MANAGER ||
    role === UserRole.MFG_MANAGER
  );
}
